import React from 'react'

export const Heart = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path opacity="0.84" d="M20.5821 4.28011C22.8593 6.60252 22.8591 10.4598 20.582 12.7822C19.4901 13.8962 11.9293 21.2277 11.9293 21.2277L3.27657 12.7822C0.975517 10.4343 0.975517 6.62778 3.27657 4.27996C5.79204 1.71337 9.56113 2.19003 11.9293 4.60629C14.2709 2.21708 18.0947 1.74095 20.5821 4.28011Z" fill="#242B26" fillOpacity="0.8"/>
  </svg>
);
